import { Button, Result } from 'antd';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom'; // Import hooks

const ErrorBoundariesFallback = () => {
    const error = useRouteError();
    let errorMessage = "An unexpected error occurred.";

    if (isRouteErrorResponse(error)) {
        errorMessage = `${error.status} ${error.statusText}`;
    } else if (error instanceof Error) {
        errorMessage = error.message;
    }

    return (
        <Result
            status="error"
            title="Something Went Wrong"
            subTitle={errorMessage} // Display the specific error message
            extra={
                <Button
                    type="primary"
                    onClick={() => window.location.replace('/')}>
                    Go to Homepage
                </Button>
            }
        />
    );
};

export default ErrorBoundariesFallback;